import { Calendar, momentLocalizer } from "react-big-calendar";
import { Card, Button, Space, Form, Drawer, Select, DatePicker } from "antd";
import { useMemo, useState, useRef, useEffect } from "react";
import moment from "moment";
import "./Medicaid.scss";
import classNames from "classnames";
import { useSharedState } from "../../../Shared/Services/WindowSizeService";
import BreadcrumbList from "../../../Shared/Components/Breadcrumb/Breadcrumb";
import CustomToolBar from "./CustomToolBar";
import MedicaidAgenda from "./MedicaidAgenda";
import {useMeetingsHook, useFiltersHook} from "./CustomHooks";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const localizer = momentLocalizer(moment);

const Medicaid = () => {
  const [date, setDate] = useState(new Date());
  const [defaultView, setDefaultView] = useState("month");
  const [view, setView] = useState(defaultView);
  const [currentDate, setCurrentDate] = useState(moment().startOf("day"));
  const [filterFlag, setFilterFlag] = useState(false);
  const [filterDate, setFilterDate] = useState(null);
  const [medMeetingData, setMeetings] = useState([]);
  const [meetingFilters, setMeetingFilters] = useState({
    meetingType: [],
    states: [],
    drugClasses: [],
    start: null,
    end: null,
    view: view,
  });
  const currentDateRef = useRef();
  const navigate = useNavigate();
  currentDateRef.current = currentDate || new Date();
  const currentView = useRef();
  currentView.current = defaultView;

  const windowSize$ = useSharedState();
  const [form] = Form.useForm();

   const convertDate = (date) => {
    return new Date(date);
  };

   //----Custom Hook To Fetch Medicaid Confernces ---- //
  const medicaidMeetingInfo = useMeetingsHook(meetingFilters, view);
  if(medicaidMeetingInfo?.length) {
    medicaidMeetingInfo?.map((sch, index) => {
            medicaidMeetingInfo[index].start = convertDate(
              medicaidMeetingInfo[index].start
            );
            medicaidMeetingInfo[index].end = convertDate(
              medicaidMeetingInfo[index].end
            );
          });
  }

  //----Custom Hook To Fetch Filters ---- //
  const getLists = useFiltersHook();
  const { statesList, drugClasses, meetingType } = getLists;

  const applyMeetingFilters = () => {
    const filters = form.getFieldsValue(true);
    setMeetingFilters((prev) => ({
      ...prev,
      meetingType: filters?.meetingType ? filters?.meetingType : [],
      states: filters?.states ? filters?.states : [],
      drugClasses: filters?.drugClasses ? filters?.drugClasses : [],
    }));
    // setMeetingFilters(filters);
    setFilterFlag(false);
  };

  const hanldeViewChange = (newView) => {
    setDefaultView(newView);
    setView(newView);
    setMeetingFilters((prev) => ({
      ...prev,
      view: newView,
    }));
  };

  const handleNavigate = (action, date) => {
    if (action === "TODAY") {
      setCurrentDate(moment().startOf("day"));
    } else if (action === "DATE") {
      setCurrentDate(new Date(date));
    } else if (action === "PREV") {
      setCurrentDate((prevDate) =>
        moment(prevDate).subtract(1, currentView.current).toDate()
      );
    } else if (action === "NEXT") {
      setCurrentDate((prevDate) =>
        moment(prevDate).add(1, currentView.current).toDate()
      );
    }
  };

  const openFilterDrawer = () => {
    setFilterFlag(true);
  };

  const onCloseFilter = () => {
    setFilterFlag(false);
  };

  const components = useMemo(
    () => ({
      toolbar: (props) => (
        <CustomToolBar
          handleNavigate={handleNavigate}
          updateView={hanldeViewChange}
          openFilterDrawer={openFilterDrawer}
          view={view}
          defaultView={currentView.current}
          currentDate={currentDateRef}
          {...props}
        />
      ),
    }),
    []
  );

  const columns = [
    {
      label: "Medicaid",
      link: "",
    },
  ];

  const eventPropsHandler = (event, start, end, isSelected) => {
    return {
      style: {
        backgroundColor: "transparent",
        borderRadius: "6px",
        color: event.color,
        border: "none",
        padding: "2px 6px",
        boxShadow: "none",
      },
    };
  };

  const onDrillDown = (e) => {
    console.log(e, "event fored on drill down");
  };

  const onSelectEvent = (e) => {
    navigate(`/medicaid/meetingDetails/${e.id}`)
    console.log(e, "event fired on select event");
  };

  const onShowMore = (moreEvents, date) => {
    console.log(moreEvents, "event fired on show more");
    console.log(date, "event fired on show more");
  };

  const handleCalender = (event, value, key) => {
    setFilterDate(value);
  };


  const handleEvents = (data) => {
  setMeetingFilters((prev) => ({
    ...prev,
    start: data.start || prev.start,
    end: data.end || prev.end,
  }));
};

  return (
    <div className="details-root" data-test="details-container">
      {filterFlag && (
        <Drawer
          title="Enter filter details"
          size="default"
          onClose={onCloseFilter}
          open={filterFlag}
          styles={{
            body: {
              paddingBottom: 80,
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingTop: "0px",
            },
          }}
          footer={
            <Space>
              <Button
                style={{ background: "#000000" }}
                type="primary"
                onClick={applyMeetingFilters}
              >
                Apply
              </Button>
              <Button onClick={onCloseFilter}>Cancel</Button>
            </Space>
          }
        >
          <Form form={form} layout="vertical" hideRequiredMark>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                States
              </label>
              <Form.Item name="states">
                <Select
                  mode="multiple"
                  options={statesList}
                  placeholder="Select drug classes"
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "5px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Drug Classes
              </label>
              <Form.Item name="drugClasses">
                <Select
                  placeholder="Select Drug Classes"
                  mode="multiple"
                  options={drugClasses}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
            <div className="form-item-mail" style={{ marginBottom: "15px" }}>
              <label
                class="text-only text-ellipsis-one-line-black "
                style={{ marginBottom: "8px" }}
              >
                Meeting Type
              </label>
              <Form.Item name="meetingType">
                <Select
                  placeholder="Select Meeting"
                  mode="multiple"
                  options={meetingType}
                  style={{ width: 300 }}
                />
              </Form.Item>
            </div>
          </Form>
        </Drawer>
      )}
      <div className="container">
        <Card bodyStyle={{ padding: "10px" }}>
          <BreadcrumbList active={columns} />
        </Card>

        <Card>
          <div
            className={classNames("calendar-height calender-big", {
              "margin-classs":
                windowSize$ === "lg" ||
                windowSize$ === "xl" ||
                windowSize$ === "xxl",
              "margin-class":
                windowSize$ === "xs" ||
                windowSize$ === "sm" ||
                windowSize$ === "md",
            })}
          >
            {view && view === "month" && (
              <Calendar
                localizer={localizer}
                defaultView={defaultView}
                events={medicaidMeetingInfo}
                startAccessor="start"
                endAccessor="end"
                date={date}
                view={view}
                onNavigate={setDate}
                onView={setView}
                components={components}
                eventPropGetter={eventPropsHandler}
                drilldownView="null"
                onDrillDown={onDrillDown}
                onSelectEvent={onSelectEvent}
                popup
              />
            )}
            {view && view === "agenda" && (
              <MedicaidAgenda
                events={medicaidMeetingInfo}
                updateView={hanldeViewChange}
                currentDate={currentDateRef}
                view={view}
                handleEvents={handleEvents}
                startDate={meetingFilters.start}
                endDate={meetingFilters.end}
              />
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Medicaid;
